import { Injectable } from '@angular/core';
import { UserData } from './user.model';
import { HttpClient } from '@angular/common/http';
import { shareReplay } from 'rxjs/operators';
import { AppSettings } from '../../app.settings';
import { OAuthService } from 'common';
import { defer, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient, private settings: AppSettings, private oauthService: OAuthService) { }

  private _current$: Observable<UserData> | null = null;

  get current() {
    if (!this._current$) {
      this._current$ = defer(() => 
        this.http.get<UserData>(`${this.settings.oauth.url}/api/user`)
      ).pipe(
        shareReplay(1)
      );
    }
    return this._current$;
  }
}
